import React from 'react';
import { FormField } from '../../../../components/FormField';
import { FormRow } from '../../../../components/FormRow';
import { formatArea } from '../../../../../../../utils/formatters';

interface PromotionBasicInfoProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const promotionTypes = [
  'Résidentielle',
  'Commerciale',
  'Mixte',
  'Hôtelière',
  'Industrielle',
];

export const PromotionBasicInfo: React.FC<PromotionBasicInfoProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  // Gestionnaire pour les champs de surface (supprime les décimales)
  const handleAreaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // Supprimer tout sauf les chiffres
    const numericValue = value.replace(/[^\d]/g, '');
    
    handleInputChange({
      target: {
        name,
        value: numericValue,
        type: 'text'
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };
  return (
    <>
      <FormRow>
        <FormField label="Type de promotion">
          <select
            name="promotionType"
            value={property?.promotion_type || formData.promotionType || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {promotionTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </FormField>

        <FormField label="Superficie totale (m²)">
          <input
            type="text"
            name="totalArea"
            value={formatArea(property?.total_area || formData.totalArea)}
            onChange={handleAreaChange}
            placeholder="0"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField label="Nombre total d'étages">
          <input
            type="number"
            name="totalFloors"
            value={property?.total_floors ?? formData.totalFloors ?? ''}
            onChange={handleInputChange}
            min="1"
          />
        </FormField>

        <FormField label="Nombre de lots">
          <input
            type="number"
            name="totalLots"
            value={property?.total_units ?? formData.totalLots ?? ''}
            onChange={handleInputChange}
            min="1"
          />
        </FormField>
      </FormRow>

      <FormField label="Date de livraison">
        <input
          type="date"
          name="deliveryDate"
          value={property?.delivery_date || formData.deliveryDate || ''}
          onChange={handleInputChange}
        />
      </FormField>
    </>
  );
};